import { useEffect, useState } from 'react'
import { getCustomerNumber } from '../util'
import { API_ENDPOINTS } from '../../../api'
import { useFetchCustomerData } from './useFetchCustomerData'

export const useGetCustomerNameListSettings = () => {
    const customerNumber = getCustomerNumber()
    const apiUrl = API_ENDPOINTS.NAMELIST_CUSTOMER({customerNumber});
    const { data, loading } = useFetchCustomerData(apiUrl)
    return { customerNameListSettings: data, customerNameListSettingsLoading: loading }
}
